/** Cantidades tactiles: botones ≥44px + entrada decimal directa. */
export function QuantityStepper({
  label,
  value,
  onChange,
}: {
  label: string;
  value: number;
  onChange: (next: number) => void;
}) {
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        aria-label={`Disminuir cantidad de ${label}`}
        disabled={value <= 0}
        onClick={() => onChange(Math.max(0, value - 1))}
        className="h-11 w-11 rounded-full border border-border-light bg-bg-tertiary text-xl text-text-primary transition-colors hover:bg-border-light disabled:opacity-40"
      >
        −
      </button>
      <input
        type="text"
        inputMode="decimal"
        aria-label={`Cantidad de ${label}`}
        value={String(value)}
        onChange={(e) => {
          const parsed = Number(e.target.value.replace(',', '.'));
          onChange(Number.isFinite(parsed) && parsed >= 0 ? parsed : 0);
        }}
        className="h-11 w-16 rounded-xl border border-border text-center text-base tabular-nums"
      />
      <button
        type="button"
        aria-label={`Aumentar cantidad de ${label}`}
        onClick={() => onChange(value + 1)}
        className="h-11 w-11 rounded-full border border-border-light bg-bg-tertiary text-xl text-text-primary transition-colors hover:bg-border-light"
      >
        +
      </button>
    </div>
  );
}
